import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Wrapper, StyledGrid, StyledCommands } from './styled';
import { MAT_CONFIGS } from '../matConfigs';
import { getBoardSlice } from '../boardSlices';
import { actions as commandsActions, selectors as commandsSelectors } from '../Mat/Commands/commandsSlice';
import Field from '../Field';
import Labels, { LABEL_TOP_NAME, LABEL_LEFT_NAME } from './Labels';
import AxisLabels from './AxisLabels';
import ClearButton from '../../../Common/ClearButton';
import { useFetchBoardFromUrl } from '../useFetchBoardFromUrl';

const Board = ({ configId }) => {
    const config = MAT_CONFIGS[configId];
    const { actions, selectors } = getBoardSlice(configId);
    const board = useSelector(selectors.selectBoard);
    const commands = useSelector(commandsSelectors.selectBoard);
    useFetchBoardFromUrl();
    const { t } = useTranslation();

    const [cols, rows] = config.gridSize;
    const isCoordinate = config.labels.type === 'coordinate';

    return (
        <Wrapper $hasCommands={config.hasCommands} $hasEdgeLabels={!isCoordinate}>
            {!isCoordinate && (
                <>
                    <Labels position={LABEL_TOP_NAME} config={config} />
                    <Labels position={LABEL_LEFT_NAME} config={config} />
                </>
            )}
            <StyledGrid
                id={configId}
                $cols={cols}
                $rows={rows}
                $hasAxisLines={config.hasAxisLines}
            >
                {board.map((row, rowIndex) => row.map((diskId, columnIndex) => (
                    <Field
                        key={`${rowIndex}-${columnIndex}`}
                        setBoardField={actions.setBoardField}
                        resetBoardField={actions.resetBoardField}
                        rowIndex={rowIndex}
                        columnIndex={columnIndex}
                        diskId={diskId}
                    />
                )))}
                {isCoordinate && <AxisLabels config={config} />}
            </StyledGrid>
            <ClearButton
                clearAction={actions.resetBoardState}
                content={t('Wyczyść matę')}
                modalContent={t('Czy na pewno chcesz wyczyścić matę?')}
                gridarea="clear"
                showTranslationButton
            />
            {config.hasCommands && (
                <>
                    <StyledCommands>
                        {commands.map((row, rowIndex) => row.map((diskId, columnIndex) => (
                            <Field
                                key={`cmd-${rowIndex}-${columnIndex}`}
                                setBoardField={commandsActions.setBoardField}
                                resetBoardField={commandsActions.resetBoardField}
                                rowIndex={rowIndex}
                                columnIndex={columnIndex}
                                diskId={diskId}
                            />
                        )))}
                    </StyledCommands>
                    <ClearButton
                        clearAction={commandsActions.resetBoardState}
                        content={t('Wyczyść listę komend')}
                        modalContent={t('Czy na pewno chcesz wyczyścić listę komend?')}
                        gridarea="clearCommands"
                    />
                </>
            )}
        </Wrapper>
    );
};

export default Board;
